module.exports = __webpack_public_path__ + "static/media/main-privacy-image.cfe1fc4a.png";